import React from 'react';
import { Typography, List, ListItem, ListItemText, Box } from '@mui/material';
import { facility } from '../../models/DashboardInformation';

interface FacilityInformationProps {
    data: facility | null;
}

// Phone number formatting function
const formatPhoneNumber = (phone: string | null): string => {
    if (!phone || phone.length !== 10) {
        return 'N/A'; // Return 'N/A' if phone is invalid
    }

    const areaCode = phone.slice(0, 3);
    const centralOfficeCode = phone.slice(3, 6);
    const lineNumber = phone.slice(6, 10);

    return `(${areaCode}) ${centralOfficeCode}-${lineNumber}`;
};

const FacilityInformation: React.FC<FacilityInformationProps> = ({ data }) => {
    if (!data) {
        return (
            <div>
                <Typography mb={2} variant="h3" color="text.secondary">Facility Information</Typography>
                <Typography>No data found</Typography>
            </div>
        );
    }

    return (
        <Box p={2} border={'1px solid #000'} borderColor={'divider'} height={'100%'}>
            <Typography mb={2} variant="h3" color="text.secondary">Facility Information</Typography>
            <List>
                <ListItem>
                    <ListItemText primary="Facility Name:" secondary={data.name || 'N/A'} />
                </ListItem>
                <ListItem>
                    <ListItemText primary="Facility Manager:" secondary={''} />
                </ListItem>
                <ListItem>
                    <ListItemText primary="Facility City:" secondary={data.city || 'N/A'} />
                </ListItem>
                <ListItem>
                    <ListItemText primary="Facility Address:" secondary={data.address || 'N/A'} />
                </ListItem>
                <ListItem>
                    <ListItemText primary="Facility Phone:" secondary={formatPhoneNumber(data.phone)} />
                </ListItem>
                <ListItem>
                    <ListItemText primary="Facility E-Mail:" secondary={data.email || 'N/A'} />
                </ListItem>
            </List>
        </Box>
    );
};

export default FacilityInformation;
